import { useEffect, useState } from "react";

const calc = (target) => {
  const diff = new Date(target).getTime() - Date.now();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, done: true };
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    minutes: Math.floor((diff / 60000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    done: false,
  };
};

export const Countdown = ({ target, dark = false }) => {
  const [t, setT] = useState(() => calc(target));
  useEffect(() => {
    const id = setInterval(() => setT(calc(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const units = [
    { label: "Days", v: t.days },
    { label: "Hours", v: t.hours },
    { label: "Minutes", v: t.minutes },
    { label: "Seconds", v: t.seconds },
  ];

  return (
    <div className="flex gap-3 sm:gap-4" data-testid="countdown">
      {units.map((u) => (
        <div
          key={u.label}
          className={`flex flex-col items-center rounded-2xl px-4 py-3 sm:px-6 sm:py-4 min-w-[70px] sm:min-w-[88px] border ${
            dark ? "bg-white/10 border-white/20 text-white backdrop-blur-md" : "bg-white border-black/5 text-ink shadow-warm"
          }`}
        >
          <span className="font-display text-3xl sm:text-5xl font-semibold tabular-nums leading-none">
            {String(u.v).padStart(2, "0")}
          </span>
          <span className={`mt-1 text-[10px] sm:text-xs uppercase tracking-[0.2em] ${dark ? "text-white/70" : "text-ink-soft"}`}>
            {u.label}
          </span>
        </div>
      ))}
    </div>
  );
};
